import confetti from 'canvas-confetti'
import Confetti from 'components/confetti/Confetti'
import { Button } from 'components/UI'
import { BACKEND_REGISTRATION_CODES } from 'constants'
import { TUTOR_ROLE } from 'constants'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { getUser, logout, setStep, switchRole } from 'routing/fetchingfunction/user/user.action'
import {
  selectAccessToken,
  selectRegisterStep,
  selectRole,
} from 'routing/fetchingfunction/user/user.reducer'

const ApolloJourney = ({ role }) => {
  const dispatch = useDispatch()
  const [showConfetti, setShowConfetti] = useState(true)

  const registerRole = useSelector(selectRole)
  const accessToken = useSelector(selectAccessToken)
  const registerStep = useSelector(selectRegisterStep)
  const navigate = useNavigate()
  const [loading, setLoading] = useState()

  const handleExitRegistration = async () => {
    try {
      // Dispatch logout and wait for it to complete
      await dispatch(logout()).unwrap()
      //console.log('Logout completed, redirecting to homepage')

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Logout completed, redirecting to homepage')
      }

      // Only navigate after logout is complete
      navigate('/')
    } catch (error) {
      console.error('Error during logout:', error)
      // Still try to navigate to homepage even if logout fails
      navigate('/')
    }
  }

  const isTutor = role === TUTOR_ROLE

  const handleClick = () => {
    if (registerRole !== role) {
      // Dispatch switchRole and wait for it to complete before navigating
      dispatch(switchRole(role))
        .unwrap()
        .then((result) => {
          console.log(`Role switched to ${role}, now navigating to dashboard`)
          // Navigation will happen automatically through the Link's to prop
        })
        .catch((error) => {
          console.error('Error switching roles:', error)
        })
    }

    console.log('Registration complete, keeping COMPLETED status')
  }

  useEffect(() => {
    if (accessToken) {
      dispatch(getUser())
    }

    // Automatically hide confetti after some time to improve performance
    const timer = setTimeout(() => {
      setShowConfetti(false)
    }, 35000)

    return () => clearTimeout(timer)
  }, [dispatch, accessToken])

  useEffect(() => {
    confetti({
      particleCount: 800,
      spread: 120,
      origin: { y: 0.6 },
    })
  }, [])

  return (
    <div
      className={`bg-[#FEEBDD] rounded-lg py-16 px-6 sm:px-10 md:px-20 lg:px-32 xl:px-36 text-[#F67443] max-w-4xl w-full mx-auto my-16 flex flex-col items-center justify-start relative overflow-hidden"`}
    >
      {/* {showConfetti && <Confetti />} */}
      {isTutor ? (
        <div className=" max-w-xl m-auto text-white">
          <h3 className="text-2xl  sm:text-5xl font-bold z-20 text-center text-primary-100">
            Congratulations!
          </h3>
          <p className="text-xl  sm:text-3xl text-primary-100 leading-10 mt-2 font-semibold mb-20 z-20 text-center">
            All passed categories have been created successfully
          </p>
        </div>
      ) : (
        <h3 className="text-2xl sm:text-3xl font-semibold mb-20 z-20 text-center">
          {' '}
          Thanks for registering with Apolo!{' '}
        </h3>
      )}
      <div className="mb-[79px] w-[200px] glowing h-[200px] rounded-full overflow-hidden bg-transparent z-20">
        <img
          className="  block w-full h-full object-contain mix-blend-multiply"
          src="/assets/image/trophy.gif"
          alt="trophy"
          style={{
            objectFit: 'contain',
            background: 'transparent',
            filter: 'drop-shadow(0px 0px 8px rgba(0,0,0,0.1))',
          }}
        />
      </div>
      <div>
        <p className="font-semibold my-4 text-lg text-center leading-8 p-6 text-primary-100">
          You’re officially register as a member, and we couldn’t be more excited. Our team is
          working hard behind the scenes to build a platform that empowers your learning and
          teaching journey. We’ll let you know as soon as we launch, your Apolo journey is just
          around the corner.{' '}
        </p>
      </div>
      <Button
        onClick={handleExitRegistration}
        // to={isTutor ? `/${role}` : `/${STUDENT_ROLE}/find-tutor`}
        className="shadow border !border-gray-600/30 max-w-lg w-full rounded-[8px] bg-primary-button hover:bg-primary-button-hover shadow-button h-[44px] flex items-center justify-center text-base font-semibold text-white transition-colors duration-200 ease z-20"
        // onClick={handleClick}
      >
        Log Out
        {/* {isTutor ? 'Go to your Dashboard' : 'Find Your Tutor'} */}
      </Button>
      {role === TUTOR_ROLE && (
        <Button
          loading={loading}
          onClick={() => {
            dispatch(
              setStep({
                step: BACKEND_REGISTRATION_CODES.COMPLETED,
                skipBackendUpdate: true,
              })
            )
            navigate(`/${role}/register/pass-test?test-step=7&status=completed`, {
              replace: true,
            })
          }}
          // className="shadow border !border-gray-600/30 max-w-lg w-full rounded-[8px] bg-primary-button hover:bg-primary-button-hover shadow-button h-[44px] flex items-center justify-center text-base font-semibold text-white transition-colors duration-200 ease z-20"

          className="w-full  font-medium shadow max-w-lg mt-3 transition border !border-primary-100 !text-primary-75 bg-white"
        >
          Take Another Test
        </Button>
      )}
    </div>
  )
}

export default ApolloJourney
